module.exports = __webpack_public_path__ + "static/img/division_2.4accb84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/fortnite/division_2.svg
// module id = NmJP
// module chunks = 35